// extracted by mini-css-extract-plugin
export var externalLink = "_9o-0";
export var internalLinkLabel = "_9o-1";